module.exports = {"430121001":"星沙街道","430121002":"泉塘街道","430121003":"湘龙街道","430121004":"榔梨街道","430121005":"长龙街道","430121102":"黄兴镇","430121104":"江背镇","430121105":"黄花镇","430121106":"春华镇","430121107":"果园镇","430121108":"路口镇","430121109":"高桥镇","430121110":"金井镇","430121111":"福临镇","430121112":"青山铺镇","430121113":"安沙镇","430121114":"北山镇","430121116":"开慧镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430121.json
// module id = 1658
// module chunks = 0